import { on } from '../core/event-bus.js';

export class AppToast extends HTMLElement {
  private shadow: ShadowRoot;
  private cleanup?: () => void;

  constructor() {
    super();
    this.shadow = this.attachShadow({ mode: 'open' });
  }

  connectedCallback(): void {
    this.shadow.innerHTML = `
      <style>
        :host {
          position: fixed;
          bottom: 24px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 9999;
          pointer-events: none;
        }
        .toast {
          padding: 12px 24px;
          border-radius: 8px;
          font-size: .875rem;
          color: #fff;
          box-shadow: 0 4px 16px rgba(0,0,0,.2);
          animation: slide-up .3s ease;
          pointer-events: auto;
        }
        .toast.info { background: #323232; }
        .toast.success { background: var(--color-success, #2e7d32); }
        .toast.error { background: var(--color-error, #ba1a1a); }
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
      </style>
    `;

    this.cleanup = on('toast', (e: CustomEvent) => {
      const { message, type = 'info' } = e.detail as { message: string; type?: string };
      this.show(message, type);
    });
  }

  disconnectedCallback(): void {
    this.cleanup?.();
  }

  private show(message: string, type: string): void {
    const el = document.createElement('div');
    el.className = `toast ${type}`;
    el.textContent = message;
    this.shadow.appendChild(el);
    setTimeout(() => el.remove(), 3000);
  }
}

customElements.define('app-toast', AppToast);
